import { allowAccessToNotifications } from '@juvare/contact-management/backend/features/permissions/shared';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import CampaignIcon from '@mui/icons-material/Campaign';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import { Box } from '@mui/material';
import React from 'react';
import { Navigate } from 'react-router';
import { AlertsListArchived, AlertsListDraft, AlertsListSent, AlertsListTemplate } from '../features/alerts';
import { NotificationsListInbox, NotificationsListInboxArchived } from '../features/inbox';
import { useAlertUiTranslation } from './useAlertUiTranslation';
export function useAlertsRoutes() {
    const { t } = useAlertUiTranslation();
    const userState = useUserState();
    const routes = [];
    // Everybody has access to Notifications / Inbox page, other Notifications pages require special permissions
    const notificationsChildren = [];
    routes.push({
        path: 'notifications',
        handle: {
            type: 'tabs',
            label: t('common.notifications'),
            icon: React.createElement(CampaignOutlinedIcon, null),
            iconSelected: React.createElement(CampaignIcon, null),
            gradient: 'blue-base',
            navigateTo: 'notifications/inbox',
        },
        children: notificationsChildren,
    });
    notificationsChildren.push({
        path: 'inbox',
        element: (React.createElement(Box, { sx: { p: 4 } },
            React.createElement(NotificationsListInbox, null))),
        handle: {
            type: 'tab',
            label: t('common.inbox'),
        },
    });
    notificationsChildren.push({
        path: 'inbox-archived',
        element: (React.createElement(Box, { sx: { p: 4 } },
            React.createElement(NotificationsListInboxArchived, null))),
        handle: {
            type: 'tab',
            label: t('common.inboxArchived'),
        },
    });
    notificationsChildren.push({
        path: 'inbox/archived',
        element: React.createElement(Navigate, { replace: true, to: '../inbox-archived' }),
    });
    if (allowAccessToNotifications(userState)) {
        notificationsChildren.push({
            path: 'sent',
            element: (React.createElement(Box, { p: 4 },
                React.createElement(AlertsListSent, null))),
            handle: {
                type: 'tab',
                label: t('common.sent'),
            },
        });
        notificationsChildren.push({
            path: 'archived',
            element: (React.createElement(Box, { p: 4 },
                React.createElement(AlertsListArchived, null))),
            handle: {
                type: 'tab',
                label: t('common.sentArchived'),
            },
        });
        notificationsChildren.push({
            path: 'drafts',
            element: (React.createElement(Box, { p: 4 },
                React.createElement(AlertsListDraft, null))),
            handle: {
                type: 'tab',
                label: t('common.drafts'),
            },
        });
        notificationsChildren.push({
            path: 'templates',
            element: (React.createElement(Box, { p: 4 },
                React.createElement(AlertsListTemplate, null))),
            handle: {
                type: 'tab',
                label: t('common.templates'),
            },
        });
    }
    return routes;
}
